import { ApiService } from 'js/src/client/services.gen';
import type { Template } from 'js/src/client/types.gen';

/**
 * Look up a single template the user can build on, by id — the same universe the
 * find_templates tool draws from. Returns the template when the id is real and
 * accessible, otherwise null.
 *
 * create_blank_video and rebuild_video use this as their one source of truth for
 * "is this a usable template?": it both validates the id and yields the template's
 * supported aspect ratios. So a template the agent found via find_templates is
 * honoured, rather than rejected and substituted for a prompt template the user
 * never asked for.
 */
export async function findAccessibleTemplate(templateId: string): Promise<Template | null> {
    try {
        const response = await ApiService.templatesRetrieve({ path: { id: templateId } });
        return response.data ?? null;
    } catch {
        // A failed lookup means the id is unknown or not accessible to this user — an
        // expected outcome (the model may pass a stale or made-up id), not an error.
        return null;
    }
}
